module.exports = __webpack_public_path__ + "img/ic_modif_rose.ae4e1cd6.svg";